"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
exports.envStore = function (env) {
    var get = function (flagName) {
        return utils_1.safeParseJSON(env[utils_1.getKey(flagName)] || null);
    };
    return {
        name: 'envStore',
        get: get,
        all: function () { return utils_1.mapFromStoredValuesWithPrefix(env, get); }
    };
};
//# sourceMappingURL=env-store.js.map